import React from 'react'
import PropTypes from 'prop-types'
import SelectButtonRaw from '~/components/common/SelectButton'

const SelectButton = ({ field, form, disabled, ...props }) => (
  <SelectButtonRaw
    {...field}
    onChange={(value) => form.setFieldValue(field.name, value)}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
  />
)

SelectButton.defaultProps = {
  disabled: false,
}

SelectButton.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default SelectButton
